window.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("med_searchInput");
  const resultsDiv = document.getElementById("med_results");

  if (input) {
    fetch("/cdn/shop/t/5/assets/drugdata.json?")
      .then((res) => res.json())
      .then((dataset) => {
        const tableHeader = `<thead><tr><th>Medical/Generic Name</th><th>Brand Name</th></tr></thead>`;

        const groupedData = dataset.reduce((acc, item) => {
          const categories = item.C.split(","); // Split the categories
          categories.forEach((category) => {
            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push(item);
          });
          return acc;
        }, {});

        let groupedDataAccordion = "";
        Object.keys(groupedData).forEach((key, index) => {
          const group = groupedData[key];
          const groupList = group
            .map(
              (med) =>
                `<tr><td class="w-1/2">${med.D}</td><td class="w-1/2">${med.T}</td></tr>`
            )
            .join("");
          groupedDataAccordion += `
              <div class="accordion">
              <details class="details" is="accordion-details" aria-expanded="false">
                  <summary class="details__summary flex items-center justify-between gap-2 cursor-pointer">
                  <span class="text-base lg:text-3xl xl:text-3xl leading-tight">${key}</span>
                  <svg class="icon icon-plus-alt icon-xs flex-auto" viewBox="0 0 14 14" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M7 1V13M13 7H1"></path>
                  </svg></summary>
                  <div class="details__content text-base rte max-w-full">
                  <div class="specification grid grid-cols-12 gap-6 md:gap-10"><div class="col-span-full bg-tan p-6 rounded"><table class="w-full">${tableHeader}<body>${groupList}</tbody></table></div></div>
                  </div>
              </details>
              </div>
              `;
        });
        resultsDiv.innerHTML = groupedDataAccordion;

        input.addEventListener("input", () => {
          const searchStr = input.value.toLowerCase().trim();
          resultsDiv.innerHTML = ""; // Clear previous results

          const filteredResults = dataset.filter(
            (med) =>
              med.D.toLowerCase().includes(searchStr) ||
              med.T.toLowerCase().includes(searchStr)
          );

          if (searchStr === "") {
            resultsDiv.innerHTML = groupedDataAccordion; // Clear previous results
          } else if (filteredResults.length === 0) {
            resultsDiv.innerHTML = "<p>The medicine entered was not found.</p>";
          } else {
            const resultList = filteredResults
              .map(
                (med) =>
                  `<tr><td class="w-1/2">${med.D}</td><td class="w-1/2">${med.T}</td></tr>`
              )
              .join("");
            resultsDiv.innerHTML = `<div class="bg-tan p-6 rounded"><table class="w-full">${tableHeader}${resultList}</table></div>`;
          }
        });
      });
  }
});
